// extracted by mini-css-extract-plugin
export default {"PaymentSaveEmailDialog":"styles_PaymentSaveEmailDialog__-TNdj","contentMessage":"styles_contentMessage__62SY8","message":"styles_message__-tNKK"};